import type { ReactNode } from 'react';
import React from 'react';

import { CardInspire } from '@xing-com/card';
import { NotOnSmall, OnlyOnSmall } from '@xing-com/layout-primitives';

export const SwopCardInspire: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  return (
    <React.Fragment>
      <OnlyOnSmall>
        <CardInspire padding="regular" size="small" variant={8}>
          {children}
        </CardInspire>
      </OnlyOnSmall>
      <NotOnSmall>
        <CardInspire padding="regular" size="large" variant={8}>
          {children}
        </CardInspire>
      </NotOnSmall>
    </React.Fragment>
  );
};
